import { library } from "@fortawesome/fontawesome-svg-core";
import { faGoogle, faGithub, faYoutube, faAmazon } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
// import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

library.add(faGoogle, faGithub, faEnvelope, faYoutube, faAmazon);

// faXTwitter
